import { render, staticRenderFns } from "./EmployerInformation.vue?vue&type=template&id=85577a88&scoped=true"
import script from "./EmployerInformation.vue?vue&type=script&lang=js"
export * from "./EmployerInformation.vue?vue&type=script&lang=js"
import style0 from "./EmployerInformation.vue?vue&type=style&index=0&id=85577a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85577a88",
  null
  
)

export default component.exports